<template>
    <div>
        <v-card elevation="6">
            <div class="pa-3">
                <div class="grid_select">
                    <div class="grid_header">
                        <div class="mx-auto">
                            <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_debit_card" :src="img_debit_card"/>
                        </div>
                        <div class="pt-3 pl-2" style="font-size: 26px"><b>การชำระค่าสินค้าประจำเดือน</b></div>
                    </div>
                    <div class="grid_half">
                        <div class="ma-2">
                            <v-select color="#86bc3a" @input="dump_data_select()" :items="month" item-text="name" item-value="id" v-model="selected_month" prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" hide-details="auto" outlined></v-select>
                        </div>
                        <div class="ma-2">
                            <v-select color="#86bc3a" @input="dump_data_select()" :items="year_arr" item-text="show_year" item-value="year_eng" v-model="selected_year" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
                        </div>
                    </div>
                </div>
                <div class="grid_half">
                    <div class="ma-3">
                        <v-card elevation="3">
                            <div class="pa-3">
                                <div class="font_dairy"><b>ยอดเงินเครดิตที่จ่ายไป</b></div>
                                <div class="grid_count mt-2">
                                <div class="mx-auto">
                                    <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_visa" :src="img_visa"/>
                                </div>
                                <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(credit) }}</b></div>
                                </div>
                            </div>
                        </v-card>
                    </div>
                    <div class="ma-3">
                        <v-card elevation="3">
                            <div class="pa-3">
                                <div class="font_dairy"><b>ยอดเงินสดที่จ่ายไป</b></div>
                                <div class="grid_count mt-2">
                                <div class="mx-auto">
                                    <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_money_bag_report" :src="img_money_bag_report"/>
                                </div>
                                <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(debit) }}</b></div>
                                </div>
                            </div>
                        </v-card>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>
<script>
import {formatNumber} from "@/js/handler";
import img_debit_card from "@/assets/debit-card.png";
import img_visa from "@/assets/debt.png";
import img_money_bag_report from "@/assets/money-bag-report.png";
import {HTTP} from "@/axios";

export default {
    data(){
        return{
            img_debit_card:img_debit_card,
            img_visa:img_visa,
            img_money_bag_report:img_money_bag_report,
            month: [
                {id: 1, name: 'มกราคม'},
                {id: 2, name: 'กุมภาพันธ์'},
                {id: 3, name: 'มีนาคม'},
                {id: 4, name: 'เมษายน'},
                {id: 5, name: 'พฤษภาคม'},
                {id: 6, name: 'มิถุนายน'},
                {id: 7, name: 'กรกฎาคม'},
                {id: 8, name: 'สิงหาคม'},
                {id: 9, name: 'กันยายน'},
                {id: 10, name: 'ตุลาคม'},
                {id: 11, name: 'พฤศจิกายน'},
                {id: 12, name: 'ธันวาคม'},
            ],
            year_arr: [],
            selected_month: null,
            selected_year: null,
            credit: 0,
            debit: 0,
        }
    },
    methods:{
        format_number: function (value) {
            return formatNumber(value)
        },
        async year_function() {
            this.year_arr = []
            let arr_year = [0, 1, 2]
            let count_year = new Date()
            let full_year = count_year.getFullYear()
            let month_selected = count_year.getMonth() + 1
            for (let i = 0; i < arr_year.length; i++) {
                let count_th = ((full_year + 543) - i);
                let count_eng = ((full_year) - i);
                this.year_arr.push({
                    id: i,
                    year_th: count_th,
                    year_eng: count_eng,
                    show_year: 'ปี ' + count_th,
                })
            }
            this.selected_month = month_selected
            this.selected_year = this.year_arr[0].year_eng
            await this.dump_data_select()
        },
        async dump_data_select() {
            this.credit = 0
            this.debit = 0
            await HTTP.post('/inventory/dashboards/reportpay', {
                month: this.selected_month,
                year: this.selected_year
            }).then((res) => {
                if (res.data.success === true) {
                    this.credit = res.data.credit
                    this.debit = res.data.debit
                }
            })
        },
    },
    mounted() {
        this.year_function()
    }
}
</script>

<style scoped>
.grid_header {
    display: grid;
    grid-template-columns: 10% 90%;
}
.grid_select {
  display: grid;
  grid-template-columns: 70% 30%;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.font_dairy {
  font-size: 20px !important;
}
.grid_count {
  display: grid;
  grid-template-columns: 15% 85%;
}
@media only screen and (max-width: 1180px) {
    .grid_header {
        grid-template-columns: 30% 70%;
    }
    .grid_select {
        grid-template-columns: 50% 50%;
    }
    .font_dairy {
        font-size: 18px !important;
    }
    .grid_count {
        grid-template-columns: 20% 80%;
    }
}
@media only screen and (max-width: 500px) {
    .grid_header {
        grid-template-columns: 25% 75%;
    }
    .grid_select {
        grid-template-columns: 100%;
        grid-gap: 15px 0;
    }
    .grid_half {
        grid-template-columns: 100%;
    }
    .font_dairy {
        font-size: 16px !important;
    }
}
</style>